// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"baf9e066","558":"fae39dc6"}[chunkId] + ".chunk.css";
};